import React, { createContext, useContext, useState, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { authAPI } from '../services/api';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user,    setUser]    = useState(null);
  const [token,   setToken]   = useState(null);
  const [loading, setLoading] = useState(true);

  // Carrega sessão salva ao abrir o app
  useEffect(() => {
    (async () => {
      try {
        const storedToken = await AsyncStorage.getItem('@ybr:token');
        const storedUser  = await AsyncStorage.getItem('@ybr:user');
        if (storedToken && storedUser) {
          setToken(storedToken);
          setUser(JSON.parse(storedUser));
        }
      } catch (e) {
        console.warn('Erro ao carregar sessão:', e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, senha) => {
    const { data } = await authAPI.login(email, senha);
    await AsyncStorage.setItem('@ybr:token', data.token);
    await AsyncStorage.setItem('@ybr:user',  JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const register = async (userData) => {
    const { data } = await authAPI.register(userData);
    await AsyncStorage.setItem('@ybr:token', data.token);
    await AsyncStorage.setItem('@ybr:user',  JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    await AsyncStorage.multiRemove(['@ybr:token', '@ybr:user']);
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, isLoggedIn: !!token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
